import { render, staticRenderFns } from "./CreateStockAdjustment.vue?vue&type=template&id=963ca1b8"
import script from "./CreateStockAdjustment.vue?vue&type=script&lang=js"
export * from "./CreateStockAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports